/*
 * If you don't pass permissions property, the menu link will be visible always, independently of permissions
 */

module.exports = [
    {
        labelKey: "nav.about",
        to: "/o-nas",
        area: "left",
        type: "nav-item",
    },
    {
        labelKey: "nav.blog",
        to: "/blog",
        area: "left",
        type: "nav-item",
    },
    {
        labelKey: "nav.contact",
        to: "/kontakt",
        area: "left",
        type: "nav-item",
    },
    {
        labelKey: "nav.logo",
        to: "/",
        logo: true,
        area: "center",
    },
    {
        labelKey: "nav.login",
        to: "/auth",
        area: "right",
        type: "nav-item",
        permissions: "guest",
    },
    {
        labelKey: "nav.stylize",
        to: "/wystylizuj-mnie",
        type: "outlined",
        area: "right",
        permissions: "guest",
    },
    {
        labelKey: "nav.your-account",
        to: "/konto",
        type: "nav-item",
        area: "right",
        permissions: "User",
    },
];
